import React from 'react';
import { Button } from 'flowbite-react';
import { Question, AnswerOption, WrappedNodeMatcher } from 'sched';
import { useWorkspace } from '../../context/WorkspaceContext';
import { useAsync } from 'react-async-hook';

interface PairQuestionProps {
    question: Question;
    onAnswerSelected: (option: AnswerOption) => void;
}

const PairQuestion: React.FC<PairQuestionProps> = ({ question, onAnswerSelected }) => {

    const { safeData } = useWorkspace();

    // Type guard to ensure we're dealing with a pair question
    if (question.decision.type !== "Pair") {
        return <div>Invalid question type: expected Pair question</div>;
    }

    const { left, right } = question.decision;

    const leftNodeLabel = useAsync(async () => {
        let wrapper = new WrappedNodeMatcher(left.priority_node_id);
        return await wrapper.label(safeData);
    }, [left.priority_node_id]);

    const rightNodeLabel = useAsync(async () => {
        let wrapper = new WrappedNodeMatcher(right.priority_node_id);
        return await wrapper.label(safeData);
    }, [right.priority_node_id]);

    return (
        <div>
            <h2 className="text-xl font-bold mb-4">Consolidation Decision</h2>

            <div className="grid grid-cols-3 gap-4">
                {/* Left column - First option */}
                <div className="border rounded-lg p-4 bg-cm-bg-elevated">
                    <h3 className="font-medium mb-2">Option A</h3>
                    <div className="space-y-2">
                        {/* TODO show the label {left.priority_node_id} */}
                        {leftNodeLabel.result}

                        {left.options.map((option, index) => (
                            <div key={index} className="p-2 border rounded bg-cm-bg-surface">
                                {option.text}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Center column - Context */}
                <div className="border rounded-lg p-4">
                    <h3 className="font-medium mb-2">Context</h3>
                    <div className="text-sm text-cm-text-secondary">
                        <p className="mb-2"><strong>Why compare these?</strong></p>
                        <p>{question.decision.why}</p>
                    </div>
                </div>

                {/* Right column - Second option */}
                <div className="border rounded-lg p-4 bg-cm-bg-elevated">
                    <h3 className="font-medium mb-2">Option B</h3>
                    <div className="space-y-2">
                        {rightNodeLabel.result}
                        {right.options.map((option, index) => (
                            <div key={index} className="p-2 border rounded bg-cm-bg-surface">
                                {option.text}
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Answer options */}
            <div className="mt-6 flex flex-wrap gap-2 justify-center">
                {left.options.map((option, index) => (
                    <Button
                        key={`left-${index}`}
                        color="blue"
                        onClick={() => onAnswerSelected(option.answer)}
                        className="mr-2"
                    >
                        {option.text}
                    </Button>
                ))}

                <Button
                    color="gray"
                    onClick={() => onAnswerSelected("Skip")}
                    className="mr-2"
                >
                    Skip
                </Button>

                {right.options.map((option, index) => (
                    <Button
                        key={`right-${index}`}
                        color="blue"
                        onClick={() => onAnswerSelected(option.answer)}
                        className="mr-2"
                    >
                        {option.text}
                    </Button>
                ))}
            </div>
        </div>
    );


    return (
        <div>
            <h2 className="text-xl font-bold mb-4">Consolidation Decision</h2>
        </div>
    );
};

export default PairQuestion;
